import Invitations from '~/components/TradeMining/components/Invitations'
import i18n from '~/i18n'
import { HOST } from '~/constants/host'

export const getStaticProps = async () => {
  const t = i18n.t

  return {
    props: {
      openGraphData: [
        {
          property: 'og:url',
          content: `${HOST}/lon/mining/trade/invitations`,
          key: 'ogurl',
        },
        {
          property: 'og:title',
          content: t('meta_lon_trade_title'),
          key: 'ogtitle',
        },
        {
          property: 'og:description',
          content: t('meta_lon_trade_description'),
          key: 'ogdesc',
        },
      ],
    },
  }
}
export default Invitations
